import { ClientType } from '@/lib/bridge';
import { useAppState } from '@/redux/hooks/app';
import { exhaustiveGuard } from '@/utils/exhaustiveGuard';

import { usePlatform } from './usePlatform';

export /**
 * useECommercePaths is quick helper for formatting URLs to the format expected
 * by Android and iOS. This is only neccessary when Otter is trying to call into
 * native to open a Sailfish route (i.e. - product catalog page)
 *
 * @return {*}
 */
const useECommercePaths = () => {
  const { platform } = usePlatform();
  const { brand, parkUri } = useAppState();

  const getBasePath = (platform: ClientType) => {
    switch (platform) {
      case ClientType.Web:
        // Web is just for logging purposes
        return '/web';
      case ClientType.Android:
        return `/${brand}/${parkUri}`;
      case ClientType.iOS:
        return `/${parkUri}`;
      default:
        return exhaustiveGuard(platform);
    }
  };
  const basePath = getBasePath(platform);

  const productCatalogPath = (id: string) => `${basePath}/products/catalog/${id}`;

  return { cartPath: `${basePath}/checkout/cart`, productCatalogPath };
};
